import api from "./httpService";

export const addPackageService = async (payload: any) => {
    const response = await api.post('/packages', payload);
    return response.data;
}
export const getPackages = async () => {
    const response = await api.get("/packages");
    return response.data;
};

export const getPackageAnalytics = async (startDate: string, endDate: string) => {
    const query = new URLSearchParams();
    query.set("startDate", startDate);
    query.set("endDate", endDate);

    const response = await api.get(`/packages/analytics/range?${query.toString()}`);
    return response.data;
};

export const updatePackageService = async (packageId: string, payload: any) => {
    const response = await api.put(`/packages/${packageId}`, payload);
    return response.data;
};

export const deletePackageService = async (packageId: string) => {
    const response = await api.delete(`/packages/${packageId}`);
    return response.data;
};
